import crypto from "crypto";

/* prettier-ignore */
import { CognitoIdentityProviderClient, AdminCreateUserCommand,ListUsersCommand } from "@aws-sdk/client-cognito-identity-provider";
import { REGION } from "~/_server/constants";

export const COGNITO_IDP: string = `https://cognito-idp.${REGION}.amazonaws.com/`;
export const COGNITO_USERPOOL: string = "eu-west-2_gUi1FoXY3";
export const COGNITO_CLIENTID: string = "2cskdf8d8gff49f8rn1baa6aku";
//export const COGNITO_USERPOOL: string = "eu-west-2_Z9UGIz3X7";
//export const COGNITO_CLIENTID: string = "6q8o02g8hkc67st0pkdojtvbpu";

export const COGNITO_ISSUER: string = `${COGNITO_IDP}${COGNITO_USERPOOL}`;

const generatePassword = ( length = 12 ) => {
	"use server";
	const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const lower = "abcdefghijklmnopqrstuvwxyz";
	const digits = "0123456789";
	const symbols = "!@#$%^&*()-_=+[]{}";
	const all = upper + lower + digits + symbols;

	// Ensure at least one of each
	let password = [
		upper[Math.floor(Math.random() * upper.length)],
		lower[Math.floor(Math.random() * lower.length)],
		digits[Math.floor(Math.random() * digits.length)],
		symbols[Math.floor(Math.random() * symbols.length)],
	];

	// Fill the rest
	for (let i = password.length; i < length; i++) {
		password.push(all[crypto.randomInt(0, all.length)]);
	}

	// Shuffle
	return password.sort(() => 0.5 - Math.random()).join("");
};

export const findCognitoUserByEmail = async ( email: string ) => {
	"use server";

	try {
		const client = new CognitoIdentityProviderClient( { region: REGION } );
		const command = new ListUsersCommand( {
			UserPoolId: COGNITO_USERPOOL,
			Filter: `email = "${email}"`,
			Limit: 1, // optional
		} );

		const r = await client.send( command );

		return r.Users?.[0] ?? null;
	} catch ( err ) {
		console.error( "Error finding Cognito user:", err );
		return null;
	}
};

export const createCognitoUser = async (
	email: string,
	familyName: string,
	givenName: string,
	id: number
) => {
	"use server";

	try {
		const client = new CognitoIdentityProviderClient( { region: REGION } );
		//const tempPassword = generatePassword(); // Because Cognito requires one. This will never be used.

		const attrbs = [
			{ Name: "email", Value: email },
			{ Name: "email_verified", Value: "true" },
			{ Name: "profile", Value: id.toString() },
			{ Name: "family_name", Value: familyName },
			{ Name: "given_name", Value: givenName },
			{ Name: "preferred_username", Value: email },
			{ Name: "zoneinfo", Value: "Europe/London" },
		];

		console.log( "Creating Cognito user with attributes:", attrbs );
		// Cognito usernames must match [\p{L}\p{M}\p{S}\p{N}\p{P}]+ — whitespace is not allowed
		const usernamePart = ( s: string ) => s.replace( /\s+/g, "" );

		try {
			const command = new AdminCreateUserCommand( {
				UserPoolId: COGNITO_USERPOOL,
				Username: `${usernamePart( givenName )}.${usernamePart( familyName )}.#${id}`.toLowerCase(), // Ensure uniqueness

				UserAttributes: attrbs,
				//TemporaryPassword: tempPassword,
				MessageAction: "SUPPRESS", // Don't send any invitations
			} );

			const r = await client.send( command );
			
		
			return r.User ?? null;
		} catch ( err ) {
			console.error( "Error sending AdminCreateUserCommand:", err );
			return null;
		}
	} catch ( err ) {
		console.error( "Error creating Cognito user:", err );
		return null;
	}
};
